const moneyFormat = (amount) => { 
    return amount.toLocaleString("es-US", {
        style: 'currency',
        currency: 'USD',
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
    });
}

export default moneyFormat